import React from 'react';
import { formatNumber } from 'utils/formatting';
import { REWARD_TYPE } from 'utils/rewards';
import CasinoTicketIcon from '../assets/Label_CasinoTickets.png';
import CouponIcon from '../assets/Label_Coupon.png';
import DrawingTicketIcon from '../assets/Label_DrawingTickets.png';
import EntertainmentIcon from '../assets/Label_Entertainment.png';
import FoodIcon from '../assets/Label_Food.png';
import FreeDrinkIcon from '../assets/Label_FreeDrink.png';
import FreePlaycon from '../assets/Label_FreePlay.png';
import HotelIcon from '../assets/Label_Hotel.png';
import LocationRibbon from '../assets/Ribbon.png';
import MerchandiseIcon from '../assets/Label_Merchandise.png';
import ShoppingIcon from '../assets/Label_Shopping.png';
import SpaIcon from '../assets/Label_Spa.png';
import WScoreIcon from '../assets/Label_WScore.png';
import './WStoreUtils.css';

export function getCategoryLogo(classCode) {
  switch (classCode) {
    case 'D - Entertainment':
      return EntertainmentIcon;
    case 'D - Ticket':
      return DrawingTicketIcon;
    case 'F - Food and Beverage':
      return FoodIcon;
    case 'F - Free Drink':
      return FreeDrinkIcon;
    case 'G - Electronic promo Credit to Machine':
      return FreePlaycon;
    case 'H - Room':
      return HotelIcon;
    case 'K - Casino Ticket':
      return CasinoTicketIcon;
    case 'U - Coupon':
      return CouponIcon;
    case 'U - Merchandise':
      return MerchandiseIcon;
    case 'WScore':
      return WScoreIcon;
    case 'S - Spa':
      return SpaIcon;
    default:
      return ShoppingIcon;
  }
}

export function getCategoryItemClassName(classCode) {
  const classMappings = {
    'A - Promo Perk': 'wstore-item-PromoPerks',
    'A - Verse Perk': 'wstore-item-PromoPerks',
    'A - Property Perk': 'wstore-item-PromoPerks',
    'D - Entertainment': 'wstore-item-Entertainment',
    'D - Ticket': 'wstore-item-OnlineEntries',
    'F - Food and Beverage': 'wstore-item-FoodCredit',
    'F - Free Drink': 'wstore-item-FoodCredit',
    'G - Electronic promo Credit to Machine': 'wstore-item-FreePlay',
    'H - Room': 'wstore-item-Hotel',
    'U - Merchandise': 'wstore-item-Merchandise',
    WScore: 'wstore-item-WScore',
    'S - Spa': 'wstore-item-Spa',
    Quest: 'wstore-item-Quest',
    [REWARD_TYPE.PARTNERS]: 'wstore-item-Partner'
  };

  return classMappings[classCode] || 'wstore-item-default';
}

export function getCasinoLocation(item) {
  const location =
    !item || item.locations.length > 1
      ? 'All'
      : item.locations.length > 0
      ? item.locations[0]
      : 'All';
  return location.replace(/ /g, '');
}

export function getLocationText(item) {
  return !item || item.locations.length > 1
    ? ''
    : item.locations.length > 0
    ? item.locations[0].split(' ').slice(0, 1).join('')
    : 'All';
}

export function getLocationImage(item) {
  if (item && item.locations.length === 1 && !item.locations.includes('All')) {
    const textClass = 'location-text wstore-color-' + getCasinoLocation(item);
    return (
      <div className="location">
        <img className="location-icon" src={LocationRibbon} alt="" />
        <div className={textClass}>{getLocationText(item)}</div>
      </div>
    );
  }
  return null;
}

export function getStockInfo(itemCount, showUnlimited) {
  const limitedStock = !itemCount.unlimitedInventory;
  const limitedAvailable = itemCount.purchaseType !== 'Unlimited';
  if (!showUnlimited && !limitedStock) {
    return null;
  }
  const stockCount = limitedStock
    ? formatNumber(itemCount.availableCount)
    : 'Unlimited';
  const stockLabel = limitedStock || limitedAvailable ? 'In Stock' : null;
  return (
    <div className="stock-info">
      <div className="stock-count">{stockCount}</div>
      {stockLabel && <div className="stock-label">{stockLabel}</div>}
    </div>
  );
}

export function getAvailableInfo(itemCount) {
  if (itemCount.purchaseType === 'Unlimited') {
    return null;
  }
  const title =
    itemCount.purchaseType === 'Per Day' ? 'Available Today' : 'Available';
  return (
    <div className="available-info">
      <div className="available-count">
        {formatNumber(itemCount.purchaseLeft)}
      </div>
      <div className="available-label">{title}</div>
    </div>
  );
}

export function getValidityString(item) {
  if (item != null) {
    if (!item.claimStartDate || !item.claimEndDate) {
      return 'Valid: No expiration date';
    } else if (item.claimStartDate === item.claimEndDate) {
      return 'Valid: ' + item.claimStartDate;
    } else {
      return 'Valid: ' + item.claimStartDate + ' - ' + item.claimEndDate;
    }
  }
  return null;
}

export function getModalHeaderClass(item) {
  return 'modal-header wstore-background-color-' + getCasinoLocation(item);
}

export function getModalBodyBackgroundClass(item) {
  return 'modal-body wstore-background-image-' + getCasinoLocation(item);
}

export function checkGemsCost(item, patronAssets) {
  return (
    (item.wscore ? patronAssets.wscore >= item.wscore : true) &&
    (item.nuggetCost ? patronAssets.nuggets >= item.nuggetCost : true) &&
    (item.rubyCost ? patronAssets.rubies >= item.rubyCost : true) &&
    (item.sapphireCost ? patronAssets.sapphires >= item.sapphireCost : true) &&
    (item.wchipCost ? patronAssets.wchips >= item.wchipCost : true)
  );
}

export function isPurchaseEnabled(item, patronAssets) {
  if (!item) {
    return false;
  }

  const inStock =
    item.wstoreItemCount.unlimitedInventory ||
    item.wstoreItemCount.availableCount > 0;
  const available =
    item.wstoreItemCount.purchaseType === 'Unlimited' ||
    item.wstoreItemCount.purchaseLeft > 0;

  return checkGemsCost(item, patronAssets) && inStock && available;
}

export function isItemAvailable(item) {
  const inStock =
    item.wstoreItemCount.unlimitedInventory ||
    item.wstoreItemCount.availableCount > 0;
  const available =
    item.wstoreItemCount.purchaseType === 'Unlimited' ||
    item.wstoreItemCount.purchaseLeft > 0;

  return inStock && available;
}

export function isInstantPurchase(item, categoryFilter) {
  return (
    (item && item.classCode === 'D - Ticket') ||
    (item && item.classCode === 'Quest') ||
    categoryFilter.value === 'WheelWins' ||
    categoryFilter.value === 'WScore'
  );
}

export function getQuestDurationString(duration) {
  let durationArray = duration.split(',');
  let days = parseInt(
    durationArray[0].substring(0, durationArray[0].length),
    10
  );
  let hours = parseInt(
    durationArray[1].substring(0, durationArray[1].length),
    10
  );
  let minutes = parseInt(
    durationArray[2].substring(0, durationArray[2].length),
    10
  );

  let formattedDuration = `${days} day(s)`;
  if (hours > 0) {
    formattedDuration += `, ${hours} hour(s)`;
  }
  if (minutes > 0) {
    formattedDuration += `, ${minutes} minute(s)`;
  }

  return formattedDuration;
}

export function isQuest(item) {
  return item && item.classCode === 'Quest';
}

export function isQuestActive(item) {
  return !!item && item.prizeData.questAwardData.isActive;
}

export function isPartners(item) {
  return item && item.classCode === REWARD_TYPE.PARTNERS;
}

export function isUber(item) {
  return item && item.subCategory === REWARD_TYPE.UBER;
}

export function getQuestStockCount(item) {
  if (isQuest(item)) {
    const questAwardData = item.prizeData.questAwardData;
    const maxAwards = questAwardData.quest.maxAwards;
    const awardCount = questAwardData.awardCount;

    if (maxAwards === null) {
      return Infinity;
    }

    return maxAwards - awardCount;
  }

  return null;
}

export function getQuestStockInfo(item) {
  const count = getQuestStockCount(item);
  const countDisplay = count === Infinity ? 'Unlimited' : count;

  return (
    <div className="stock-info">
      <div className="stock-count">{countDisplay}</div>
      {count !== Infinity ? <div className="stock-label">In Stock</div> : null}
    </div>
  );
}

// Convert the gems needed for the trade to the equivalent WScore.
// If exchange rate is null, the gem can't be traded, in which case
// this returns a WScore value of -1.
export function getWScoreValueForGemsToTrade(
  gemCost,
  patronGems,
  exchangeRate
) {
  if (patronGems >= gemCost) {
    return 0;
  } else if (!exchangeRate) {
    return -1;
  } else {
    return (gemCost - patronGems) * exchangeRate;
  }
}

// Get the WScore equivalent of an item's gem cost based on the exchange rate.
export function getWScoreEquivalentOfGemCost(
  item,
  exchangeRates,
  patronAssets
) {
  const { nuggetCost, rubyCost, sapphireCost, wchipCost } = item;
  const { nuggets, rubies, sapphires, wchips } = patronAssets;
  const { wscorePerNugget, wscorePerRuby, wscorePerSapphire, wscorePerWChip } =
    exchangeRates;

  if (exchangeRates) {
    const nuggetsWScoreValue = getWScoreValueForGemsToTrade(
      nuggetCost,
      nuggets,
      wscorePerNugget
    );
    const rubiesWScoreValue = getWScoreValueForGemsToTrade(
      rubyCost,
      rubies,
      wscorePerRuby
    );
    const sapphiresWScoreValue = getWScoreValueForGemsToTrade(
      sapphireCost,
      sapphires,
      wscorePerSapphire
    );
    const wchipsWScoreValue = getWScoreValueForGemsToTrade(
      wchipCost,
      wchips,
      wscorePerWChip
    );

    // If any one of the gem WScore equivalents is -1, that means either the guest doesn't have
    // enough gems, or there is no exchange rate for the gem, so it cannot be traded.
    // In this case, this function returns -1 to indicate that a trade cannot be offered.
    if (
      nuggetsWScoreValue === -1 ||
      rubiesWScoreValue === -1 ||
      sapphiresWScoreValue === -1 ||
      wchipsWScoreValue === -1
    ) {
      return -1;
    } else {
      return (
        nuggetsWScoreValue +
        rubiesWScoreValue +
        sapphiresWScoreValue +
        wchipsWScoreValue
      );
    }
  } else {
    return -1;
  }
}
